import React, { useEffect } from 'react';
import { useTask } from '../../context/TaskContext';
import { FaSearch, FaFilter, FaTimes } from 'react-icons/fa';
import './TaskFilter.css';

const TaskFilter = () => {
  const { filter, updateFilter, clearFilter, getTasks } = useTask();

  useEffect(() => {
    getTasks();
  }, [filter, getTasks]);

  const handleFilterChange = (e) => {
    updateFilter({ [e.target.name]: e.target.value });
  };

  const handleSearchChange = (e) => {
    updateFilter({ search: e.target.value });
  };

  const handleClearFilter = () => {
    clearFilter();
  };

  return (
    <div className="task-filter card">
      <div className="filter-header">
        <FaFilter className="filter-icon" />
        <h3>Filter Tasks</h3>
      </div>
      
      <div className="filter-controls">
        <div className="search-box">
          <FaSearch className="search-icon" />
          <input
            type="text"
            name="search"
            value={filter.search}
            onChange={handleSearchChange}
            placeholder="Search tasks..."
            className="search-input"
          />
        </div>

        <div className="filter-selects">
          <select
            name="status"
            value={filter.status}
            onChange={handleFilterChange}
            className="filter-select"
          >
            <option value="">All Status</option>
            <option value="todo">To Do</option>
            <option value="in-progress">In Progress</option>
            <option value="completed">Completed</option>
          </select>

          <select
            name="priority"
            value={filter.priority}
            onChange={handleFilterChange}
            className="filter-select"
          >
            <option value="">All Priority</option>
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
          </select>

          {(filter.status || filter.priority || filter.search) && (
            <button 
              onClick={handleClearFilter}
              className="btn btn-outline clear-btn"
            >
              <FaTimes /> Clear
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TaskFilter;
